<div class="modal-header">
  <h4 class="modal-title">Manual Barcode Entry</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <input class="form-control"
         [(ngModel)]="barcode"
         (click)="handleInputClick()"
         #manualBarcodeInput>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-primary"
          [disabled]="barcode.trim() === ''"
          [class.disabled]="barcode.trim() === ''"
          (click)="submitCallback(barcode.trim());activeModal.dismiss();">
    Submit
  </button>
</div>
